<template>
  <v-dialog
    :value="true"
    max-width="290"
    persistent
  >
    <v-card>
      <v-card-title class="text-h5">
        Удалить?
      </v-card-title>
      <v-card-text>Вы уверены, что надо удалить?</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="$emit('close')"
        >
          Нет
        </v-btn>
        <v-btn
          color="red darken-1"
          text
          @click="$emit('delete')"
        >
          Да
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {}
</script>

<style></style>
